'use client'

import { useDebounce } from 'hooks/use-debounce'
import { cn } from 'lib/utils'
import { Input } from 'primitives/input'
import { useEffect, useState } from 'react'

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounceMs = 800,
  ...props
}: {
  value: string | number
  onChange: (value: string | number) => void
  debounceMs?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = useState(initialValue)
  const debouncedValue = useDebounce(value, debounceMs)

  // Sync with initialValue when it changes
  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  // Call onChange when debounced value changes
  useEffect(() => {
    if (debouncedValue !== initialValue) {
      onChange(debouncedValue)
    }
  }, [debouncedValue, onChange, initialValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  return (
    <Input
      {...props}
      className={cn('font-inter text-s-400 normal-case tracking-normal', props.className)}
      value={value}
      onChange={handleChange}
    />
  )
}
